import React from 'react'
import { Link } from '~/code/components'
import translations from './translations'

translations.add('en', {
    message: (openModal, tryAgain) => <>If you are experiencing any issues please <Link hasUnderline={ true } inline={ true } onClick={ openModal }>report it</Link> or <Link hasUnderline={ true } inline={ true } onClick={ tryAgain }>retry</Link></>
})
